module.exports = __webpack_public_path__ + "static/media/next-icon-call-staff-o.a67819d8.svg";